import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  sidebarCollapsed: false,
  toasts: [],
  activeModal: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleSidebar(state) { state.sidebarCollapsed = !state.sidebarCollapsed; },
    setSidebarCollapsed(state, action) { state.sidebarCollapsed = Boolean(action.payload); },
    openModal(state, action) { state.activeModal = action.payload; },
    closeModal(state) { state.activeModal = null; },
    pushToast: {
      reducer(state, action) { state.toasts.push(action.payload); },
      prepare(payload) { return { payload: { id: nanoid(), variant: "info", ...payload } }; },
    },
    dismissToast(state, action) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, openModal, closeModal, pushToast, dismissToast } = uiSlice.actions;
export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed;
export const selectActiveModal = (state) => state.ui.activeModal;
export const selectToasts = (state) => state.ui.toasts;
export default uiSlice.reducer;
